import { useState, useEffect } from "react";

const isWindowApplicationTabletWidth = () =>
  globalThis.document.documentElement.clientWidth >= 600 &&
  globalThis.document.documentElement.clientWidth <= 768;

const useApplicationTabletChecker = () => {
  const [isTablet, setIsTablet] = useState(isWindowApplicationTabletWidth);
  useEffect(() => {
    const handleResize = () => setIsTablet(isWindowApplicationTabletWidth);
    globalThis.addEventListener("resize", handleResize);
    return () => globalThis.removeEventListener("resize", handleResize);
  }, []);
  return isTablet;
};

export default useApplicationTabletChecker;
